import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { DollarSign } from 'lucide-react';

interface RefundReportTotalsProps {
  flightTotal: number;
  accommodationTotal: number;
  deductibleTotal: number;
  perDiemTotal: number;
  grandTotal: number;
  currency: string;
}

export const RefundReportTotals: React.FC<RefundReportTotalsProps> = ({
  flightTotal,
  accommodationTotal,
  deductibleTotal,
  perDiemTotal,
  grandTotal,
  currency,
}) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  const totalRows = [
    { label: 'Total Flights', amount: flightTotal, highlight: false },
    { label: 'Total Accommodation', amount: accommodationTotal, highlight: false },
    { label: 'Total Other Expenses', amount: deductibleTotal, highlight: false },
    { label: 'Total Per Diem', amount: perDiemTotal, highlight: false },
    { label: 'Total Refund', amount: grandTotal, highlight: true },
  ];

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2">
          <DollarSign className="h-5 w-5" />
          Refund Summary
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {totalRows.map((row, index) => (
            <div
              key={index}
              className={`flex items-center justify-between py-2 ${
                row.highlight
                  ? 'border-t-2 border-primary pt-3 mt-2'
                  : index > 0
                  ? 'border-t border-border'
                  : ''
              }`}
            >
              <span
                className={`${
                  row.highlight
                    ? 'font-bold text-lg'
                    : 'font-medium text-muted-foreground'
                }`}
              >
                {row.label}
              </span>
              <span
                className={`${
                  row.highlight
                    ? 'font-bold text-lg text-primary'
                    : 'font-semibold tabular-nums'
                }`}
              >
                {formatCurrency(row.amount)} {currency}
              </span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
